import * as React from 'react';
import { st, classes } from './ColorPickerItem.st.css';
import { RadioButton } from 'wix-ui-core/dist/es/src/components/radio-button';
import { TPAComponentsContext } from '../../TPAComponentsConfig';
import { TOOLTIP_COMMON_PROPS } from './tooltipCommonProps';
import { MobileTooltip } from './MobileTooltip';
import { Tooltip } from '../../Tooltip';
import { colorPickerItemDataHook, colorPickerItemDataCrossed, colorPickerItemCheckedDateHook, colorPickerItemTooltipDataHook, } from '../dataHooks';
export class ColorPickerItem extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { focused: false, focusedByKeyboard: false };
        this._onHover = () => {
            this.setState({ focused: true });
        };
        this._onIconBlur = () => {
            this.setState({ focused: false });
        };
        this._onFocusByKeyboard = () => {
            this.setState({ focusedByKeyboard: true });
        };
        this._onBlur = () => {
            this.setState({ focusedByKeyboard: false });
        };
        this._getColorDotContent = () => {
            const { value } = this.props;
            return (React.createElement("div", { className: classes.radioOuter },
                React.createElement("div", { className: classes.radioInner, style: { backgroundColor: value } })));
        };
    }
    _getTooltipProps() {
        const { mobile } = this.context;
        const { tooltip, tooltipDataHook } = this.props;
        return mobile
            ? { tooltip }
            : Object.assign({ content: tooltip, 'data-hook': tooltipDataHook }, TOOLTIP_COMMON_PROPS);
    }
    _getColorDot() {
        const { mobile } = this.context;
        const { tooltip } = this.props;
        let colorDot = this._getColorDotContent();
        if (tooltip) {
            const TooltipType = (mobile ? MobileTooltip : Tooltip);
            const tooltipProps = this._getTooltipProps();
            colorDot = React.createElement(TooltipType, Object.assign({}, tooltipProps), colorDot);
        }
        return colorDot;
    }
    render() {
        const { mobile } = this.context;
        const { focused, focusedByKeyboard } = this.state;
        const { className, checked, 'aria-label': ariaLabel, tooltipDataHook, disabled, value, onChange, name, isCrossedOut, } = this.props;
        const colorDot = this._getColorDot();
        return (React.createElement(RadioButton, Object.assign({ className: st(classes.root, {
                checked,
                focused,
                focusedByKeyboard,
                unavailable: isCrossedOut,
            }, className) }, {
            [colorPickerItemDataCrossed]: isCrossedOut,
            [colorPickerItemCheckedDateHook]: checked && !disabled,
        }, { "aria-label": ariaLabel, "data-hook": colorPickerItemDataHook, "data-tooltip-hook": tooltipDataHook, disabled: disabled, checked: checked && !disabled, checkedIcon: colorDot, value: value, uncheckedIcon: colorDot, onChange: onChange, name: name, onHover: mobile ? undefined : this._onHover, onIconBlur: mobile ? undefined : this._onIconBlur, onFocusByKeyboard: !mobile ? this._onFocusByKeyboard : undefined, onBlur: !mobile ? this._onBlur : undefined })));
    }
}
ColorPickerItem.displayName = 'ColorPickerItem';
ColorPickerItem.defaultProps = {
    tooltipDataHook: colorPickerItemTooltipDataHook,
};
ColorPickerItem.contextType = TPAComponentsContext;
//# sourceMappingURL=ColorPickerItem.js.map